import {
  ArrowLeftRight,
  Activity,
  CalendarDays,
  ClipboardList,
  GraduationCap,
  LayoutDashboard,
  LockKeyhole,
  Megaphone,
  ScrollText,
  ShieldCheck,
  UserCog,
  UserRoundCog,
  Users,
  UsersRound,
} from 'lucide-react'
import { AppShell } from './AppShell'
import { isSuperadmin } from '../../features/auth/permissions'
import { useAuth } from '../providers/auth-context'
import type { NavigationSection } from './navigation'
import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { listTotpFactors } from '../../features/auth/api'

function OperationsSecurityNotice() {
  const factors = useQuery({ queryKey: ['admin-totp-factors'], queryFn: listTotpFactors })
  if (!factors.data || factors.data.some((factor) => factor.status === 'verified')) return null
  return (
    <div className="notice security-notice" role="status">
      <span>Keselamatan: aktifkan MFA untuk melindungi akses operasi global anda.</span>
      <Link className="button button--secondary" to="/admin/settings">
        Aktifkan MFA
      </Link>
    </div>
  )
}

export function AdminLayout() {
  const { access } = useAuth()
  const superadmin = isSuperadmin(access?.roles ?? [])
  const globalOperations = Boolean(access?.canManageGlobalOperations)
  const sections: NavigationSection[] = superadmin
    ? [
        {
          label: 'Utama',
          items: [{ to: '/admin', label: 'Ringkasan', icon: LayoutDashboard, end: true }],
        },
        {
          label: 'Keahlian',
          items: [
            { to: '/admin/applications', label: 'Permohonan', icon: ClipboardList },
            { to: '/admin/alumni', label: 'Alumni', icon: Users },
            { to: '/admin/operations-admins', label: 'Pentadbir alumni', icon: UserRoundCog },
            { to: '/admin/users', label: 'Pentadbir batch', icon: UserCog },
            { to: '/admin/batches', label: 'Batch SPM', icon: GraduationCap },
          ],
        },
        {
          label: 'Komuniti',
          items: [
            { to: '/admin/events', label: 'Acara', icon: CalendarDays },
            { to: '/admin/communities', label: 'Komuniti', icon: UsersRound },
            { to: '/admin/moderation', label: 'Moderasi', icon: ShieldCheck },
            { to: '/admin/announcements', label: 'Pengumuman', icon: Megaphone },
          ],
        },
        {
          label: 'Sistem',
          items: [
            { to: '/admin/audit', label: 'Audit', icon: ScrollText },
            { to: '/admin/activity', label: 'Aktiviti operasi', icon: Activity },
            { to: '/admin/settings', label: 'Keselamatan', icon: LockKeyhole },
          ],
        },
      ]
    : globalOperations
      ? [
          {
            label: 'Utama',
            items: [{ to: '/admin', label: 'Ringkasan', icon: LayoutDashboard, end: true }],
          },
          {
            label: 'Keahlian',
            items: [
              { to: '/admin/applications', label: 'Permohonan', icon: ClipboardList },
              { to: '/admin/alumni', label: 'Alumni', icon: Users },
              { to: '/admin/users', label: 'Pentadbir batch', icon: UserCog },
            ],
          },
          {
            label: 'Komuniti',
            items: [
              { to: '/admin/events', label: 'Acara', icon: CalendarDays },
              { to: '/admin/communities', label: 'Komuniti', icon: UsersRound },
              { to: '/admin/moderation', label: 'Moderasi', icon: ShieldCheck },
              { to: '/admin/announcements', label: 'Pengumuman', icon: Megaphone },
            ],
          },
          {
            label: 'Operasi',
            items: [
              { to: '/admin/activity', label: 'Aktiviti operasi', icon: Activity },
              { to: '/admin/settings', label: 'Keselamatan', icon: LockKeyhole },
            ],
          },
          {
            label: 'Ruang lain',
            items: [{ to: '/app', label: 'Ruang alumni', icon: ArrowLeftRight }],
          },
        ]
      : [
          {
            label: 'Keahlian',
            items: [
              {
                to: '/admin/applications',
                label: `Permohonan Batch ${access?.adminBatchYear ?? ''}`.trim(),
                icon: ClipboardList,
              },
            ],
          },
          {
            label: 'Komuniti',
            items: [
              { to: '/admin/events', label: 'Acara batch', icon: CalendarDays },
              { to: '/admin/communities', label: 'Komuniti batch', icon: UsersRound },
              { to: '/admin/moderation', label: 'Moderasi', icon: ShieldCheck },
            ],
          },
          {
            label: 'Sistem',
            items: [{ to: '/admin/settings', label: 'Keselamatan', icon: LockKeyhole }],
          },
          {
            label: 'Ruang lain',
            items: [{ to: '/app', label: 'Ruang alumni', icon: ArrowLeftRight }],
          },
        ]
  const securityNotice = globalOperations && !superadmin ? <OperationsSecurityNotice /> : null
  return <AppShell admin sections={sections} notice={securityNotice} />
}
